import { WithStyles, withStyles } from '@core/theme/utils/with-styles';

import { styles } from './Playground.styles';

export type PlaygroundProps = WithStyles<typeof styles>;

const PlaygroundComponent: React.FC<PlaygroundProps> = ({ classes }) => {
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <div className={classes.innerContent}>TODO</div>
      </div>
    </div>
  );
};

export const Playground = withStyles(styles)(PlaygroundComponent);
